import PropTypes from 'prop-types';
import React from 'react';
import CarouselThumb from './CarouselThumb';

const CarouselThumbs = ({
  selectedItem,
  deal,
  thumbCount = 5,
  onSelect,
  showMoreOnClick,
}) => {
  // add a parameter to match the original array and thumbs array
  const dealMapped = deal.images.map((image, index) => {
    image.originalIndex = index;

    return image;
  });
  const hiddenPictures = dealMapped.length - 3 - thumbCount;
  const showMore = hiddenPictures > 1 ? hiddenPictures : null;
  const thumbsStart = dealMapped.slice(0, selectedItem);
  const thumbsEnd = dealMapped.slice(selectedItem, dealMapped.length);
  const thumbsPreview = [...thumbsEnd, ...thumbsStart]
    .slice(3, dealMapped.length)
    .reverse()
    .slice(0, thumbCount);

  return (
    <>
      <div className="thumbs">
        <ul className="thumbs__wrapper col-7">
          {thumbsPreview?.map((image, index) => {
            const displayShowMore = index + 1 === thumbCount;

            return (
              <CarouselThumb
                deal={deal}
                image={image}
                index={index}
                key={`thumb_${deal.id}_${index}}`}
                onSelect={() => onSelect(image.originalIndex)}
                showMore={displayShowMore ? showMore : null}
                showMoreOnClick={
                  displayShowMore
                    ? () => {
                        showMoreOnClick();
                      }
                    : null
                }
              />
            );
          })}
        </ul>
      </div>
      <style jsx>{`
        .thumbs__wrapper {
          display: flex;
          flex-wrap: nowrap;
          list-style: none;
          margin: 0;
          padding: 0;
        }
      `}</style>
    </>
  );
};

CarouselThumbs.propTypes = {
  deal: PropTypes.object,
  onSelect: PropTypes.func,
  selectedItem: PropTypes.number,
  showMoreOnClick: PropTypes.func,
  thumbCount: PropTypes.number,
};

CarouselThumbs.defaultProps = {
  deal: {},
  onSelect: () => false,
  selectedItem: 0,
  showMoreOnClick: () => null,
  thumbCount: undefined,
};

export default CarouselThumbs;
